import { Alert } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import {
  DataTransmissionStatus,
  LastKnownState,
  State,
} from 'business/dashboard/components/last-known-state';
import { GetTbmInfosQuery, GetTbmInfosQueryResult } from 'generated/graphql';
import { useMediaType } from 'technical/media/hooks';
import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';
import Card from 'ui/card';
import Loader from 'ui/loader';

interface Props {
  tbmInfos: GetTbmInfosQueryResult;
}

const getState = (data: GetTbmInfosQuery) => {
  const isExcavating =
    data.constructionSite[0].metrics_aggregate.nodes.at(0)?.isExcavating;
  const isBuilding =
    data.constructionSite[0].metrics_aggregate.nodes.at(0)?.isBuilding;

  if (data.constructionSite.at(0)?.isCompleted) {
    return State.completed;
  }

  if (isExcavating === true && isBuilding === false) {
    return State.excavating;
  }
  if (isExcavating === false && isBuilding === true) {
    return State.building;
  }

  return State.stopped;
};

export const TunnelBoringMachineHeader = ({
  tbmInfos: { data, error, loading },
}: Props) => {
  const { t } = useTranslation();

  const { currentConstructionSite } = useAppContext();
  const { isTablet } = useMediaType();

  if (error) {
    return (
      <>
        <Card.Header title={'TBM'} />
        <Alert message={t('errors.error_generic')} type="error" />
      </>
    );
  }

  if (loading || isUndefinedOrNull(data)) {
    return (
      <>
        <Card.Header title={'TBM'} />
        <Loader />
      </>
    );
  }

  const timeZone = data.constructionSite.at(0)?.timeZone;

  const state = getState(data);

  const onlineTransmission =
    data.constructionSite?.[0].metrics_aggregate.nodes.length !== 0;

  return (
    <Card.Header
      title={
        <>
          <DataTransmissionStatus />
          {currentConstructionSite?.tunnelBoringMachineName ?? 'TBM'}
        </>
      }
      actions={
        <LastKnownState
          timeZone={timeZone}
          state={state}
          onlineTransmission={onlineTransmission}
        />
      }
      vertical={isTablet}
    />
  );
};
